<template>
  <div class="rating-modal">
    <div class="modal-overlay" @click="dismissFeedback"></div>

    <div v-if="alertMessage" class="modal-content">
      <h2 class="alert-message">{{ alertMessage }}</h2>
      <div class="button-container alert-buttons">
        <button class="submit-btn" @click="acknowledgeAlert">Close</button>
      </div>
    </div>

    <div v-else class="modal-content">
      <h2 class="alert-message">How was your ED Handoff<br />Experience for this case?</h2>
      <div class="stars-container">
        <span
          v-for="star in 5"
          :key="star"
          class="star"
          :class="{ active: star <= rating }"
          @click="updateRating(star)"
        >
          ★
        </span>
      </div>

      <div class="feedback-container">
        <textarea :value="notes" rows="4" @input="updateNotes($event?.target?.value || '')"></textarea>
      </div>

      <div class="button-container">
        <button class="dismiss-btn" @click="dismissFeedback">
          <span>Skip and<br />Close Case</span>
        </button>
        <button class="submit-btn" :disabled="!isSubmitButtonEnabled" @click="submitFeedback">
          <span v-if="isLoading" class="spinner"></span>
          <span v-else>Submit<br />and Close Case</span>
        </button>
      </div>

      <div class="dont-show-container">
        <label class="dont-show-label">
          <input type="checkbox" :value="shouldNotDisturb" @change="doNotDisturbClicked" />
          <span class="checkbox-text">Don't show again</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CaseFeedbackModal",
  computed: {
    ...mapGetters("CaseFeedback", [
      "isSubmitButtonEnabled",
      "rating",
      "notes",
      "alertMessage",
      "isLoading",
      "shouldNotDisturb",
    ]),
  },
  methods: {
    ...mapActions("CaseFeedback", [
      "updateRating",
      "updateNotes",
      "submitFeedback",
      "dismissFeedback",
      "acknowledgeAlert",
      "doNotDisturbClicked",
    ]),
  },
};
</script>

<style scoped>
.rating-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  background-color: #eeeeee;
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1001;
}

.alert-message {
  text-align: center;
  margin-bottom: 1.5rem;
  color: #333;
  font-size: 1rem;
  font-weight: 700;
}

.stars-container {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 1.5rem;
}
.star {
  font-size: 3rem;
  cursor: pointer;
  color: transparent;
  -webkit-text-stroke: 2px #ff0000;
  transition: all 0.2s ease;
}

.star:hover,
.star.active {
  color: #ff0000;
  -webkit-text-stroke: 2px #ff0000;
}

.feedback-container {
  margin-bottom: 1.5rem;
}

textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: none;
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
  width: 100%;
}

.button-container.alert-buttons {
  justify-content: center;
  margin-top: 1.5rem;
}

.dismiss-btn,
.submit-btn {
  flex: 1;
  max-width: 200px;
  min-width: 120px;
  padding: 0.75rem 1rem;
  background-color: transparent;
  color: #ff0000;
  border: 2px solid #ff0000;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.2;
  min-height: 48px;
}

@media (max-width: 480px) {
  .button-container {
    gap: 0.5rem;
  }

  .dismiss-btn,
  .submit-btn {
    max-width: none;
    padding: 0.5rem;
    font-size: 0.9rem;
  }
}

.dismiss-btn:hover,
.submit-btn:hover:not(:disabled) {
  background-color: #e6e6e6;
  border: 2px solid #ff0000;
  color: #ff0000;
}

.dismiss-btn span,
.submit-btn span {
  display: inline-block;
  white-space: pre-line;
  line-height: 1.2;
}

.submit-btn:disabled {
  background-color: transparent;
  border-color: #cccccc;
  color: #cccccc;
  cursor: not-allowed;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  border-top-color: #ff0000;
  animation: spin 1s ease-in-out infinite;
  margin: 0 0.5rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.dont-show-container {
  margin-top: 1rem;
  text-align: center;
  display: flex;
  justify-content: center;
}

.dont-show-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  user-select: none;
  flex-direction: row-reverse;
}

.dont-show-label input[type="checkbox"] {
  cursor: pointer;
  width: 16px;
  height: 16px;
  margin-left: 0.5rem;
}

.checkbox-text {
  font-size: 0.9rem;
  color: #3366ff;
}
</style>
